import React, { useEffect, useState } from "react";
import Banner from "../components/Banner";

const Complaints = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    fetch("/CompliantsData.json")
      .then((response) => response.json())
      .then((jsonData) => setData(jsonData))
      .catch((error) => console.error("Error fetching data:", error));
  }, []);

  if (!data) {
    return <div>Loading...</div>;
  }

  return (
    <section className="text-center my-10 px-4">
      {/* This Month */}
      <h4 className="text-[#0F172A] text-xl font-semibold mb-4">
        {data.monthData.heading}
      </h4>
      <div className="overflow-x-auto">
        <table className="w-full max-w-7xl mx-auto border-collapse border border-gray-300 text-[#1F2937] shadow-lg rounded-lg">
          <thead className="bg-gray-500 text-white">
            <tr>
              <th className="p-3">Sr. No.</th>
              <th className="p-3">Received from</th>
              <th className="p-3">Pending at the end of last month</th>
              <th className="p-3">Received</th>
              <th className="p-3">Resolved</th>
              <th className="p-3">Total Pending</th>
              <th className="p-3">Pending Complaints (3 months)</th>
              <th className="p-3">Avg. Resolution Time (in days)</th>
            </tr>
          </thead>
          <tbody>
            {data.monthData.rows.map((row, index) => (
              <tr key={index} className="hover:bg-gray-100">
                <td className="p-3">{row.srNo}</td>
                <td className="p-3">{row.receivedFrom}</td>
                <td className="p-3">{row.pendingLastMonth}</td>
                <td className="p-3">{row.received}</td>
                <td className="p-3">{row.resolved}</td>
                <td className="p-3">{row.totalPending}</td>
                <td className="p-3">{row.pendingComplaints}</td>
                <td className="p-3">{row.avgResolutionTime}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Trend of Monthly Disposal */}
      <h4 className="text-[#0F172A] text-xl font-semibold mt-10 mb-4">
        {data.monthlyTrend.heading}
      </h4>
      <div className="overflow-x-auto">
        <table className="w-full max-w-7xl mx-auto border-collapse border border-gray-300 text-[#1F2937] shadow-lg rounded-lg">
          <thead className="bg-gray-500 text-white">
            <tr>
              <th className="p-3">Sr. No.</th>
              <th className="p-3">Month</th>
              <th className="p-3">Carried Forward from Previous Month</th>
              <th className="p-3">Received</th>
              <th className="p-3">Resolved</th>
              <th className="p-3">Pending</th>
            </tr>
          </thead>
          <tbody>
            {data.monthlyTrend.rows.map((row, index) => (
              <tr key={index} className="hover:bg-gray-100">
                <td className="p-3">{row.srNo}</td>
                <td className="p-3">{row.month}</td>
                <td className="p-3">{row.carriedForward}</td>
                <td className="p-3">{row.received}</td>
                <td className="p-3">{row.resolved}</td>
                <td className="p-3">{row.pending}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Trend of Annual Disposal */}
      <h4 className="text-[#0F172A] text-xl font-semibold mt-10 mb-4">
        {data.annualTrend.heading}
      </h4>
      <div className="overflow-x-auto">
        <table className="w-full max-w-7xl mx-auto border-collapse border border-gray-300 text-[#1F2937] shadow-lg rounded-lg">
          <thead className="bg-gray-500 text-white">
            <tr>
               <th className="p-3">Sr. No.</th>
              <th className="p-3">Year</th>
              <th className="p-3">Carried Forward from Previous Annual</th>
              <th className="p-3">Received</th>
              <th className="p-3">Resolved</th>
              <th className="p-3">Pending</th>
            </tr>
          </thead>
          <tbody>
            {data.annualTrend.rows.map((row, index) => (
              <tr key={index} className="hover:bg-gray-100">
                <td className="p-3">{row.srNo}</td>
                <td className="p-3">{row.year}</td>
                <td className="p-3">{row.carriedForward}</td>
                <td className="p-3">{row.received}</td>
                <td className="p-3">{row.resolved}</td>
                <td className="p-3">{row.pending}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <Banner />
    </section>
  );
};

export default Complaints;
